import { titleCase } from "./index";

const mapAddressToFormValues = ({
  selectedAddress: { bed_count, bath_count, building_sq_ft, lot_sq_ft, year_built, city },
  assessmentValues,
}) => ({
  bedCount: assessmentValues.bed_count || bed_count || "",
  bathCount: assessmentValues.bath_count || bath_count || "",
  buildingSqFt: assessmentValues.building_sq_ft || building_sq_ft || "",
  lotSqFt:
    assessmentValues.lot_sq_ft || assessmentValues.lot_sq_ft === 0
      ? assessmentValues.lot_sq_ft
      : lot_sq_ft || lot_sq_ft === 0
      ? lot_sq_ft
      : "",
  yearBuilt: assessmentValues.year_built || year_built || "",
  city: assessmentValues.city || (city ? titleCase(city) : ""),
});

export default mapAddressToFormValues;
